import Debug from '@tiger/debug';
import { useMount } from '@tiger/hooks';
import { Button, Col, DatePicker, Form, Row } from 'antd';
import { useState } from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import dayjs from 'dayjs';
import FormItem from 'components/FormItem';
import Toast from 'components/Toast';
import DocumentItem from '../components/DocumentItem';
import Empty from '../components/Empty';
import store from '../request';
import './style.scss';

const format = 'MM/DD/YYYY';

const Trade: React.FC = () => {
    const [data, setData] = useState<Array<{ description: string; id: string }>>([]);
    const { $new, $render, $invalid, $batchDirty, $params, $getFirstError } = useForm<{
        startDate: string;
        endDate: string;
    }>();
    const [loading, setLoading] = useState(false);

    async function getData() {
        if ($invalid) {
            $batchDirty(true);

            Toast.show($getFirstError());

            return;
        }

        const { startDate, endDate } = $new().$params;

        setLoading(true);

        try {
            const data = await store.getTradeConfirmList(startDate, endDate);

            setData(data);
        } catch (e) {
            Toast.show(e);

            setData([]);
        }

        setLoading(false);
    }

    useMount(() => {
        $render(() => getData());
    });

    return (
        <div className="reports-trade-root pt-2">
            <div className="text-muted mb-4">
                {__('We generate daily trade confirms for every business day you have activities in your account.')}
            </div>
            <Form layout="vertical" onFinish={() => getData()}>
                <Row gutter={12}>
                    <Col span={24} md={{ span: 8 }}>
                        <FormItem
                            name="startDate"
                            label={__('From')}
                            $defaultValue={dayjs().subtract(1, 'months').format(format)}
                            $formatter={val => val && dayjs(val)}
                            $parser={val => val && dayjs(val).format(format)}>
                            <DatePicker className="w-100" format={format} allowClear={false} />
                        </FormItem>
                    </Col>
                    <Col span={24} md={{ span: 8 }}>
                        <FormItem
                            name="endDate"
                            label={__('To')}
                            $defaultValue={dayjs().format(format)}
                            $formatter={val => val && dayjs(val)}
                            $parser={val => val && dayjs(val).format(format)}>
                            <DatePicker className="w-100" format={format} allowClear={false} />
                        </FormItem>
                    </Col>
                    <Col span={24} md={{ span: 8 }} className="trade-btn-wrap align-items-center">
                        <Button htmlType="submit" block type="primary" size="large" loading={loading}>
                            {__('Search')}
                        </Button>
                    </Col>
                </Row>
            </Form>
            <div className="mt-4">
                {data?.length > 0 ? (
                    data.map((val, index) => <DocumentItem id={val.id} description={val.description} key={index} />)
                ) : (
                    <Empty />
                )}
            </div>
            <Debug data={$params} />
        </div>
    );
};

export default withForm(Trade);
